import _isDate from 'lodash-es/isDate';
import parse from 'date-fns/parse';
import { DateString, DateTimeString } from '@shared/core/types';

export function unserializeDate(value: Date | DateTimeString | DateString | any, format): Date | null {
  if (!value) {
    return null;
  }

  return _isDate(value) ? value : parse(value, format, new Date());
}
